<template>
    <div class="input-checkbox-container">
        <div
            class="input-checkbox-wrapper"
            :class="{ error: isError, disabled }"
            data-testid="input-checkbox"
        >
            <label
                class="input-checkbox-label"
            >
                <CheckTrigger
                    v-model="checked"
                    :disabled="disabled"
                    :error="isError"
                />
                <div
                    v-if="label"
                    class="label-text"
                    v-html="label"
                />
            </label>
        </div>
        <div
            v-if="error && typeof error === 'string'"
            style="padding-left: 42px; margin-top: 3px"
        >
            <ErrorText :error="error" />
        </div>
    </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { isNotNil } from 'ramda'
import CheckTrigger from './CheckTrigger.vue'
import marked from '../../utilities/marked'
import ErrorText from 'widget-components/components/ErrorText/ErrorText.vue'

const props = defineProps({
    modelValue: Boolean,
    initialValue: Boolean,
    disabled: Boolean,
    external: Boolean,
    error: [String, Boolean],
    label: String,
    blockPath: Array,
})

defineOptions({ inheritAttrs: false })

const label = computed(() => marked(props.label))

const emit = defineEmits(['update:modelValue'])

const checked = ref(isNotNil(props.initialValue) ? !!props.initialValue : !!props.modelValue)
const isError = computed(() => !!props.error)

watch(() => checked.value, (val) => {
    if (props.disabled) {
        return
    }
    emit('update:modelValue', val)
}, { deep: true, immediate: true })

watch(() => props.modelValue, (val) => {
    if (checked.value !== val) checked.value = val
})

</script>

<style scoped lang="sass">
@import './InputCheckbox.sass'
</style>
